const navigation = document.querySelector('[data-public-navigation]');
if (navigation) {
  const toggle = navigation.querySelector('.menu-button');
  const menu = navigation.querySelector('#public-nav-menu');
  const submenus = [...navigation.querySelectorAll('.submenu-toggle')];
  const hoverDesktop = window.matchMedia('(min-width: 1101px) and (hover: hover) and (pointer: fine)');
  const setSubmenu = (button, expanded) => {
    button.setAttribute('aria-expanded', String(expanded));
    document.getElementById(button.getAttribute('aria-controls')).hidden = !expanded;
  };
  const closeSubmenus = () => submenus.forEach(button => setSubmenu(button, false));
  const closeMenu = () => {
    toggle.setAttribute('aria-expanded', 'false');
    menu.classList.remove('is-open');
    closeSubmenus();
  };
  toggle.addEventListener('click', () => {
    const expanded = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(expanded));
    menu.classList.toggle('is-open', expanded);
    if (!expanded) closeSubmenus();
  });
  submenus.forEach(button => {
    const item = button.closest('.nav-item');
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      closeSubmenus();
      setSubmenu(button, expanded);
    });
    item.addEventListener('mouseenter', () => {
      if (!hoverDesktop.matches) return;
      closeSubmenus();
      setSubmenu(button, true);
    });
    item.addEventListener('mouseleave', () => {
      if (hoverDesktop.matches && !item.contains(document.activeElement)) setSubmenu(button, false);
    });
    item.addEventListener('focusout', event => {
      if (!item.contains(event.relatedTarget)) setSubmenu(button, false);
    });
  });
  navigation.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const expanded = submenus.find(button => button.getAttribute('aria-expanded') === 'true');
    if (expanded) { closeSubmenus(); expanded.focus(); }
    else { closeMenu(); toggle.focus(); }
  });
  document.addEventListener('click', event => { if (!navigation.contains(event.target)) closeMenu(); });
  navigation.addEventListener('focusout', event => { if (!navigation.contains(event.relatedTarget)) closeMenu(); });
  window.matchMedia('(min-width: 1101px)').addEventListener('change', closeMenu);
}
